import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { DefaultRoutes, PublicRoutes, QueryParamKeys, Account, AppConfiguration, useAppSelector } from "src/common";
import { Icon } from "src/components";
import _ from "lodash";

type AllProps = {
  current_account?: Account;
  accounts?: Account[];
  active: boolean;
}

const AccountLink = (props: { account: Account }) => {
  const account = props.account;
  return <Link
    to={`/${PublicRoutes.login_route}?${QueryParamKeys.USER_ID_QUERY_KEY}=${encodeURIComponent(account.user_id)}`}
    className="dropdown-item"
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`Switch to ${account.display_name} account`}>
    {account.display_name}
    <small>{account.user_id}</small>
  </Link>;
};

function AccountDropdown(props: AllProps) {
  const { current_account, accounts } = props;
  const version = useAppSelector((state) => state.app.version);
  const organization = useAppSelector((state) => state.account.organization);
  const [show, setShow] = useState(false);
  const dropdown_ref = useRef(null);

  // Description: build the Account specific for build mode: Web, Express
  function WebDropdown() {
    return <>
      <Link className="dropdown-item light" to={`/${PublicRoutes.logout_route}`} aria-label="Logout">
        <Icon className="ficon-log-out" /> Logout</Link>
      {
        AppConfiguration.buildForExpress() &&
        <Link className="dropdown-item light" to={`/${PublicRoutes.upgrade_information_route}`} aria-label="Go to PreVeil Upgrade page to learn more">
          <Icon className="ficon-star" />Upgrade PreVeil
        </Link>
      }
    </>;
  }

  return <Dropdown className="nav-item account-menu" ref={dropdown_ref} show={show} onToggle={setShow}>
    <Dropdown.Toggle as="a"
      className={`${!current_account ? " choose" : ""}`}
      aria-label="My Accounts"
      aria-haspopup="menu"
      aria-expanded={show}>
      <Icon className="pv-icon-contact show-desktop" />
      <span className="hide-desktop">Account</span>
    </Dropdown.Toggle>
    <Dropdown.Menu align="end" >
      {
        !!current_account &&
        <Dropdown.Item className="active cursor-default" aria-label={`My Account ${current_account.display_name || current_account.user_id}`}>
          <Icon className="pv-icon-contact me-0" />
          {current_account.display_name || "My Account"}
          <small>{!!organization && !!organization.org_name ? organization.org_name : current_account.user_id}</small>
        </Dropdown.Item>
      }
      {!!accounts &&
        _.map(accounts, (account: Account, i: number) => {
          return !_.isEqual(account, current_account) && <AccountLink key={`account_${i}`} account={account} />;
        })
      }
      {
        AppConfiguration.buildForWeb() ? <WebDropdown /> :
          <Link className="dropdown-item light" to={`/${PublicRoutes.get_started_route}`} reloadDocument aria-label="Add Account">
            <Icon className="pv-icon-add-account" />Add Account
          </Link>
      }
      <Dropdown.Item href={`${DefaultRoutes.remote_webapp_url}`} target="_blank" aria-label="Go to PreVeil Website">
        <Icon className="pv-icon-open" />PreVeil Website
      </Dropdown.Item>
      {
        !!version &&
        <Dropdown.Item aria-label={`PreVeil Version ${version}`}>
          <Icon className="pv-icon-key-small" />Build {version}
        </Dropdown.Item>
      }
    </Dropdown.Menu>
  </Dropdown >;
}

export default React.memo(AccountDropdown);
